exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrap-room-image[data-v-b9a5f63e]{max-height:450px;object-fit:cover;width:100%}.wrap-room-image[data-v-b9a5f63e] img{max-height:450px}.wrap-info[data-v-b9a5f63e]{background-color:var(--blue-light-1);display:grid;grid-template-columns:repeat(4,minmax(0,1fr))}@media(max-width:1200px){.wrap-info[data-v-b9a5f63e]{grid-template-columns:repeat(2,minmax(0,1fr))}}@media(max-width:600px){[data-v-b9a5f63e] .VueCarousel-wrapper{overflow:hidden!important}[data-v-b9a5f63e] .VueCarousel-slide{max-width:unset!important}}.close-btn[data-v-b9a5f63e]{position:absolute;top:16px;right:16px;z-index:10;cursor:pointer}", ""]);

// exports
